import http from '../utils/http';
import { Promise as bbPromise } from 'bluebird';

const defaultState = {
    entityName: 'channelMaps',
    baseUrl: 'api/venueChannelMaps/',
    channelMaps: [],
    channelMapsPending: false,
    channelMapsExtended: [],
    channelMapsExtendedPending: false
};

export const mutations = {
    setChannelMaps(state, value) {
        state.channelMaps = Array.isArray(value) ? value : [];
    },
    setChannelMapsPending(state, value) {
        if (typeof value === 'boolean') {
            state.channelMapsPending = value;
        } else {
            state.channelMapsPending = false;
        }
    },
    setChannelMapsExtended(state, value) {
        state.channelMapsExtended = Array.isArray(value) ? value : [];
    },
    setChannelMapsExtendedPending(state, value) {
        if (typeof value === 'boolean') {
            state.channelMapsExtendedPending = value;
        } else {
            state.channelMapsExtendedPending = false;
        }
    }
};

export const actions = {
    fetchChannelMaps({ commit, state }) {
        console.log('calling fetchChannelMaps');
        return http.get(`${state.baseUrl}?size=9999`).then(res => {
            commit('setChannelMaps', res.data.content);
        });
    },
    assignToServiceAccount({ state }, { channelMapId, serviceAccountIds }) {
        // will assign a list of serviceAccounts to the given channelMap
        // payload: { channelMapId: yyy, serviceAccountIds: [...] }
        console.log('calling assignToServiceAccount');
        if (channelMapId && serviceAccountIds) {
            return http
                .post(
                    `${state.baseUrl}${channelMapId}/assign/`,
                    serviceAccountIds,
                    {
                        notifyRequestPending: false,
                        notifySuccess: false,
                        notifyError: false
                    }
                )
                .then(res => res.data);
        }
    },
    updateDefaultChannels({ dispatch }, { oldChannelMaps, newChannelMaps }) {
        let actions = [];
        for (let i = 0; i < newChannelMaps.length; i++) {
            if (
                newChannelMaps[i].defaultChannel !==
                oldChannelMaps[i].defaultChannel
            ) {
                actions.push({
                    action: 'updateDefaultChannel',
                    payload: {
                        channelMapId: newChannelMaps[i].id,
                        channelNumber: newChannelMaps[i].defaultChannel
                    }
                });
            }
        }
        return bbPromise
            .each(actions, item => {
                return dispatch(item.action, item.payload);
            })
            .then(() => {
                dispatch('fetchChannelMaps', {
                    includeChannelOptions: true
                });
            });
    },
    updateDefaultChannel({ state }, { channelMapId, channelNumber }) {
        console.log('calling updateDefaultChannel');
        if (channelMapId && channelNumber) {
            return http.patch(
                `${state.baseUrl}${channelMapId}/defaultChannel`,
                { defaultChannel: channelNumber },
                {
                    notifyRequestPending: false,
                    notifySuccess: false,
                    notifyError: false
                }
            );
        }
    },
    fetchChannelMapOptions({ state }, { channelMapId }) {
        console.log('calling fetchChannelMapOptions');
        return http.get(`${state.baseUrl}${channelMapId}/channelOptions`);
    }
};

export default {
    namespaced: true,
    state: defaultState,
    mutations,
    actions
};
